import { styled } from "styled-components";
import { PopupBtn } from "@template/components/Popup/styles.ts";

export const SearchTabContainer = styled.form`
  display: flex;
  flex-direction: column;
  gap: 24px;
  width: 100%;
  position: relative;
`;

export const SearchGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  width: 100%;
`;

export const SearchInput = styled.div`
  width: 100%;
  display: flex;
  gap: 4px;
  align-items: flex-start;
  ${PopupBtn} {
    width: fit-content;
    min-width: 180px;
  }
`;

export const SearchButton = styled.div`
  display: flex;
  justify-content: end;
  align-items: center;
  width: 100%;
`;

export const Alert = styled.div`
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  width: fit-content;
  height: 48px;
  background: transparent;
  bottom: 0;
  left: 0;
  color: ${({ theme }) => theme.colors.primary.default};
`;
